import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import type { Option } from "../../types";
import { MultiAutocomplete } from "../../shared/MultiAutocomplete";
import { inlineInputStateStyles } from "./InlineInputState";

type MultiSelectProps = InputProps<string[]> & {
  options: Option[];
};

export const MultiSelect: FC<MultiSelectProps> = ({ options, ...props }) => {
  return (
    <MultiAutocomplete
      {...props}
      inlineInputStateStyles={inlineInputStateStyles}
      options={options}
      noOptionsTextKey="DynamicForm.Option.Empty"
      placeholderKey="DynamicForm.Inline.InputPlaceholder"
      chipVariant="choice"
    />
  );
};
